var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"food-details"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":_vm._T('Order Status'),"active":""}},[_c('OrderStatus')],1),_c('b-tab',{attrs:{"title":_vm._T('Order Detail')}},[_c('OrderDescription')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }